import { Box, Grid, Typography, Paper } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function Capabilities() {
  return (
    <Box
      id="capabilities"
      sx={{
        backgroundColor: "#F7FAFF",
        py: { xs: 6, md: 10 },
        display: "flex",
        justifyContent: "center",
        fontFamily: "Roboto, sans-serif",
      }}
    >
      {/* OUTER CONTAINER (same as About & Spares) */}
      <Box sx={{ px: { xs: 2, sm: 4, md: "250px" }, width: "100%" }}>

        {/* ================= HEADING ================= */}
        <Box sx={{ textAlign: "center", mb: 5 }}>
          <Typography
            component="h1"
            sx={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2d2075",
              lineHeight: 1.5,
              mb: 1,
            }}
          >
            Capabilities
          </Typography>

          <Box
            sx={{
              width: 90,
              height: "3px",
              backgroundColor: "#2d2075",
              borderRadius: "2px",
              mx: "auto",
            }}
          />
        </Box>

        {/* ================= WHITE CARD ================= */}
        <Paper
          elevation={2}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: "2px",
          }}
        >
          {/* ================= INTRO ================= */}
          <Typography
            component="p"
            sx={{
              fontSize: "20px",
              color: "#444",
              lineHeight: 1.5,
              mb: 5,
            }}
          >
            Engineering and Manufacturing
            We use best of technology to design and manufacture industrial filters and elements. Multitex help to protect our environment. 
            We test our filters and elements for their high performance before
            delivering to our customers. In-house Procedures are prepared based
            on the International Codes & Standards and results are recorded on
            the Observation Sheet for the following testing:
          </Typography>

          {/* ================= CONTENT GRID ================= */}
          <Grid container spacing={6} alignItems="flex-start">

            {/* LEFT CONTENT */}
            <Grid item xs={12} md={6}>
              <Typography
                component="h2"
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#2d2075",
                  mb: 2,
                  lineHeight: 1.5,
                }}
              >
                Testing & Validation
              </Typography>

              {[
                "Pressure Drop V/S Flow Rate Testing",
                "Micron Rating Testing",
                "Water Separation Testing",
                "Dirt Holding Capacity Testing",
                "Collapsibility Testing",
              ].map((item, i) => (
                <Box
                  key={i}
                  sx={{ display: "flex", alignItems: "flex-start", mb: 1.4 }}
                >
                  <CheckCircleIcon
                    sx={{ color: "#2d2075", fontSize: 18, mr: 1, mt: "4px" }}
                  />
                  <Typography
                    component="p"
                    sx={{
                      fontSize: "20px",
                      lineHeight: 1.5,
                    }}
                  >
                    {item}
                  </Typography>
                </Box>
              ))}
            </Grid>

            {/* RIGHT IMAGE */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  width: "100%",
                  aspectRatio: "4 / 3",
                  borderRadius: "2px",
                  overflow: "hidden",
                  boxShadow: "0 6px 22px rgba(0,0,0,.12)",
                }}
              >
                <img
                  src="/web9.png"
                  alt="Testing and validation of filters"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Box>
  );
}
